// extracted by mini-css-extract-plugin
module.exports = {"customAlert":"CustomAlert_customAlert__HWJMo","closeButton":"CustomAlert_closeButton__47p54","leftToRight":"CustomAlert_leftToRight__xreP3"};